import { UsedSeat, SeatType } from "../../bookmydesk-api-sdk-typescript-axios";
import { kMaps } from "./maps";

export const kSeatsUsage: UsedSeat[] = [
  {
    id: "12a0f5bd-72ab-4543-93f9-2286a82703be",
    name: "Seat 1",
    dirty: false,
    mapId: kMaps[0].id,
    coordX: 1300,
    coordY: 516,
    seatType: "desk" as SeatType,
    isZone: false,
    reservationCapacity: 1,
    zoneCoordinates: null,
  },
  {
    id: "e6f0eae9-19cd-401c-812a-aa47e3bf5868",
    name: "Seat 2",
    dirty: false,
    mapId: kMaps[0].id,
    coordX: 1308,
    coordY: 402,
    seatType: "desk" as SeatType,
    isZone: false,
    reservationCapacity: 1,
    zoneCoordinates: null,
  },
  {
    id: "a518b2b7-2c5d-4111-8369-f30106248513",
    name: "Seat 3",
    dirty: false,
    mapId: kMaps[0].id,
    coordX: 1423,
    coordY: 428,
    seatType: "desk" as SeatType,
    isZone: false,
    reservationCapacity: 1,
    zoneCoordinates: null,
  },
  {
    id: "49d8a5df-cc65-48d7-903e-8f1a5fe69083",
    name: "Seat 4",
    dirty: true,
    mapId: kMaps[0].id,
    coordX: 1459,
    coordY: 431,
    seatType: "desk" as SeatType,
    isZone: false,
    reservationCapacity: 1,
    zoneCoordinates: null,
  },
  {
    id: "c016d1ef-080b-427f-832a-69da558026cc",
    name: "Meeting 1",
    dirty: false,
    mapId: kMaps[0].id,
    coordX: 857,
    coordY: 144,
    seatType: "meeting" as SeatType,
    isZone: false,
    reservationCapacity: 1,
    zoneCoordinates: null,
  },
];
